import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../images/stephmens-logo.png';


const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className='relative flex items-center justify-between p-4 bg-white text-blue-700 shadow-md lg:w-full lg:text-xl'>
            <div className="company-logo">
                <img className="w-36" src={logo} alt="company-logo" />
            </div>
            <button className="lg:hidden text-3xl z-50" onClick={toggleMenu}>
                {isMenuOpen ? '✕' : '☰'}
            </button>
            <nav className={`lg:flex ${isMenuOpen ? 'block' : 'hidden'} w-full lg:w-auto absolute lg:relative top-full lg:top-auto right-0 lg:right-auto bg-white lg:bg-transparent transition-all duration-300 ease-in-out z-40`}>
                <ul className="flex flex-col space-y-2 p-4 lg:flex-row lg:space-x-4 lg:space-y-0">
                    <li><Link to="/" className="hover:text-yellow-500 text-blue-700 p-2 rounded-md">Home</Link></li>
                    <li className="relative group">
                        <Link to="/about" className="text-blue-700 p-2 rounded-md hover:text-yellow-500">About</Link>
                    </li>
                    <li className="relative group">
                        <Link to="/services" className="text-blue-700 p-2 rounded-md hover:text-yellow-500">Services</Link>
                    </li>
                    <li><Link to="/contacts" className="text-blue-700 hover:text-yellow-500 p-2 rounded-md">Contacts</Link></li>
                </ul>
            </nav>
        </header>
    );
};

export default Navbar;